import {Component, inject, OnInit, signal} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";
import {SnackbarComponent} from "@common/ui/snackbar/snackbar.component";

export interface InfoSnackbarData {
	translationKey: string;
	duration: number;
}

@Component({
	selector: "sim-info-snackbar",
	imports: [TranslateModule, SnackbarComponent],
	templateUrl: "./info-snackbar.component.html",
	styleUrl: "./info-snackbar.component.scss",
})
export class InfoSnackbarComponent implements OnInit {
	// Properties
	protected infoMessage = signal<string>("");

	// Injections
	protected readonly data = inject<InfoSnackbarData>(MAT_SNACK_BAR_DATA);

	public ngOnInit(): void {
		if (this.data.translationKey) {
			this.infoMessage.set(this.data.translationKey);
		}
	}
}
